// AUTO-GENERATED by scripts/generate-contracts.mjs from the .md sidecar.
// Hand edits will be overwritten on the next run. To customise this
// component's contract (add actions, structured props, custom control
// kinds, glyph pickers), remove this file's auto-generated marker and
// hand-author it — the generator skips files without the marker.

import { z } from "zod";
import { contract } from "@gradeui/contracts";

export const SelectContract = contract({
  name: "Select",
  description: "Single-choice from 3+ known options. Fewer than 3 → RadioGroup. Huge list with search → use a Combobox (not in DS yet). Multi-select → not supported by this primitive. In dense tool panels, set size=\"xs\" on BOTH the trigger and the content so the closed control and open menu match.",
  import: "@gradeui/ui",
  aliases: ["dropdown","combobox","picker","select","pop-up button","popup button","popup picker","picker view","rnpickerselect","react native picker","native picker"],
  subcomponents: ["SelectTrigger","SelectValue","SelectContent","SelectItem","SelectGroup","SelectLabel","SelectSeparator"],
  subcomponentElements: {"SelectTrigger":"button","SelectValue":"span","SelectContent":"div","SelectItem":"div","SelectGroup":"div","SelectLabel":"div","SelectSeparator":"div"},
  composesWith: ["Label (above SelectTrigger)","Form","Card"],
  styleDefaults: {"SelectTrigger":"flex w-full items-center justify-between rounded-md border border-input bg-background dark:bg-input/30 data-[placeholder]:text-muted-foreground focus-visible:outline-none focus-visible:border-ring focus-visible:ring-[3px] focus-visible:ring-ring/50 disabled:cursor-not-allowed disabled:opacity-50 [&>span]:line-clamp-1 h-9 px-3 py-1 text-sm","SelectScrollUpButton":"flex cursor-default items-center justify-center py-1","SelectScrollDownButton":"flex cursor-default items-center justify-center py-1","SelectContent":"relative z-50 max-h-96 min-w-[8rem] overflow-hidden rounded-md border bg-popover text-popover-foreground shadow-md data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2","SelectItem":"relative flex w-full cursor-default select-none items-center rounded-sm outline-none focus:bg-accent focus:text-accent-foreground focus:[&_svg]:text-accent-foreground data-[disabled]:pointer-events-none data-[disabled]:opacity-50 py-1.5 pl-8 pr-2 text-sm","SelectSeparator":"-mx-1 my-1 h-px bg-muted"},
  props: {
  "value": {
      schema: z.unknown().optional(),
      design: "plumbing",
  },
  "onValueChange": {
      schema: z.unknown().optional(),
      design: "event",
  },
  "defaultValue": {
      schema: z.unknown().optional(),
      design: "plumbing",
  },
  "disabled": {
      schema: z.unknown().optional(),
      design: "plumbing",
  },
  "name": {
      schema: z.unknown().optional(),
      design: "plumbing",
  },
  "required": {
      schema: z.unknown().optional(),
      design: "plumbing",
  },
  "autoComplete": {
      schema: z.unknown().optional(),
      design: "plumbing",
  },
  "onOpenChange": {
      schema: z.unknown().optional(),
      design: "event",
      description: "Radix root (renders no element itself, so no native-attr passthrough; name/required/autoComplete post via a hidden native select)",
  },
  "size": {
      schema: z.enum(["default", "sm", "xs"]).optional(),
      design: "knob",
      description: "control density; wraps the clickable control, nest SelectValue inside",
  },
  "placeholder": {
      schema: z.string().optional(),
      design: "content",
      description: "text when nothing is selected",
  },
  },
});
